import type { RouteLocationNormalized } from 'vue-router';

/**
 * Determina si una ruta corresponde al retorno de una pasarela de pago.
 * @param to - Ubicación de ruta normalizada a evaluar.
 * @returns `true` únicamente cuando `meta.isPaymentCallback` es exactamente `true`.
 */
export function isPaymentCallbackRoute(to: RouteLocationNormalized): boolean {
  return to.meta?.isPaymentCallback === true;
}
